import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { get, post, put } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import EditDialog from "../../../../Components/Common/EditDialog";
import LocationAutocomplete from "../../../../Components/Common/LocationAutocomplete";
import ShipAutocomplete from "../../../../Components/Common/ShipAutocomplete";
import AirportAutocomplete from "../../../../Components/Common/AirportAutocomplete";
import formatTitleWithOptional from "../../../Scope1/OptionalFeild";
import { encryptData } from "../../../../utils/cryption";
import { useUser } from "../../../../context/AuthContext";

function AddTransportation({
  inputData,
  fetchData,
  id,
  title,
  data,
  setdataView,
  setAddData,
  SelectedData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
  handleModalClose,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});
  const initialState = {
    consumptionPeriod: {
      month: SelectedData?.consumptionPeriod?.month || "",
      year: SelectedData?.consumptionPeriod?.year || "",
    },
    origin: SelectedData?.origin || "",
    emissionFactor: SelectedData?.emissionFactor || "",
    destination: SelectedData?.destination || "",
    // freightLoad: {
    //   value: SelectedData?.freightLoad?.value || "",
    //   unit: SelectedData?.freightLoad?.unit || "",
    // },
    // distanceCovered: {
    //   value: SelectedData?.distanceCovered?.value || "",
    //   unit: SelectedData?.distanceCovered?.unit || "",
    // },
    freightLoad: {
      // Parse the value to remove unnecessary decimals
      value: SelectedData?.freightLoad?.value
        ? SelectedData.freightLoad.value.toString()
        : "",
      unit: SelectedData?.freightLoad?.unit || "",
    },
    distanceCovered: {
      // Parse the value to remove unnecessary decimals
      value: SelectedData?.distanceCovered?.value
        ? SelectedData.distanceCovered.value.toString()
        : "",
      unit: SelectedData?.distanceCovered?.unit || "",
    },
    remark: SelectedData?.remark || "",
    transportationType: SelectedData?.transportationType || "",
    // travelType: SelectedData?.travelType || "",
    // className: SelectedData?.className || "",
    documents: SelectedData?.documents || [],
    editRemarkReason: SelectedData?.editRemarkReason || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  // const [travelType, setTravelType] = useState(formData.travelType || "");
  // const [classNameOptions, setClassNameOptions] = useState([]);

  // const resetFrom = () => {
  //   setFormData(SelectedData !== null ? SelectedData : initialState);
  //   setUploadedFiles(SelectedData !== null ? SelectedData : []);
  // };

  const [originCoordinates, setOriginCoordinates] = useState(null);
  const [destinationCoordinates, setDestinationCoordinates] = useState(null);

  useEffect(() => {
    if (SelectedData !== null) {
      setFormData(SelectedData);
      setFormData2(SelectedData);

      setUploadedFiles(SelectedData?.documents || []);
    } else {
      setFormData(initialState);
      setFormData2(initialState);
      // setUploadedFiles([]);
      setUploadedFiles(SelectedData !== null ? SelectedData?.documents : []);
    }
  }, [SelectedData, addData]);

  console.log("first2", formData);

  useEffect(() => {}, [SelectedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Split the name to handle nested fields
    const [baseKey, subKey] = name.split(".");

    if (
      baseKey === "freightLoad" &&
      subKey === "value" &&
      !/^\d*\.?\d*$/.test(value)
    )
      return;

    setErrors((prevErrors) => {
      // Clear nested field errors if valid
      if (baseKey === "freightLoad") {
        return {
          ...prevErrors,
          [baseKey]: {
            ...prevErrors[baseKey],
            [subKey]: undefined,
          },
        };
      }
      // Clear normal field errors
      return { ...prevErrors, [name]: undefined };
    });

    // Update the form data
    if (subKey) {
      setFormData((prevState) => ({
        ...prevState,
        [baseKey]: {
          ...prevState[baseKey],
          [subKey]: subKey === "value" ? value : value,
        },
      }));
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleChange1 = (field) => (event) => {
    const { value } = event.target;

    // Clear error for the field when user starts typing
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: null, // Reset error for the current field
    }));

    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
      ...(field === "categoryOfShipment" && { typeOfShipment: "" }),
    }));
  };

  const handleExitAgree = () => {
    setErrors({});
    setFormData(initialState);
    setFormData2(initialState);
    setEditDialog(false);
    setAddData(false);
    fetchData(); // Refresh data when exiting edit mode
    handleModalClose();
  };

  const handleClose = () => {
    const isFormDataUnchanged =
      JSON.stringify(formData) === JSON.stringify(formData2);
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
      handleModalClose();
      // Close the dialog if there are no unsaved changes
    } else {
      // handleModalClose();
      setEditDialog(true); // Show confirmation dialog if there are unsaved changes
    }
  };

  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (month === "" || !validateNumber(month))
          newErrors["month"] = "Month is required";

        if (year === "" || !validateNumber(year))
          newErrors["year"] = "Year is required";

        return;
      }

      if (input.fieldName === "freightLoad") {
        const cvValue = formData[input.fieldName]?.value || ""; // Ensure it's a string

        const cvUnit = formData[input.fieldName]?.unit || ""; // Ensure it's a string

        // if (!cvValue.trim()) {
        if (String(cvValue).trim() === "") {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Freight Load is required.",
          };
        } else if (isNaN(cvValue)) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Freight Load must be a number.",
          };
        } else if (Number(cvValue) < 0) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Freight Load must be non-negative.",
          };
        }

        if (!cvUnit) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            unit: "Unit is required.",
          };
        }
        return; // Ensure to return after handling errors for freightLoad
      }

      if (input.fieldName === "distanceCovered") {
        // const cvValue = formData[input.fieldName]?.value || "";
        // const cvUnit = formData[input.fieldName]?.unit || "";
        // if (!validateNumber(cvValue)) {
        //   newErrors[input.fieldName] = {
        //     ...newErrors[input.fieldName],
        //     value: "Numeric Value required.",
        //   };
        // }
        return;
        // if (!cvValue.trim()) {
        // if (String(cvValue).trim() === "") {
        //   newErrors[input.fieldName] = {
        //     ...newErrors[input.fieldName],
        //     value: "Distance Travelled is required.",
        //   };
        // } else if (isNaN(cvValue)) {
        //   newErrors[input.fieldName] = {
        //     ...newErrors[input.fieldName],
        //     value: "Distance Travelled must be a number.",
        //   };
        // } else if (Number(cvValue) < 0) {
        //   newErrors[input.fieldName] = {
        //     ...newErrors[input.fieldName],
        //     value: "Distance Travelled must be non-negative.",
        //   };
        // }

        // if (!cvUnit.trim()) {
        //   newErrors[input.fieldName] = {
        //     ...newErrors[input.fieldName],
        //     unit: "Unit is required.",
        //   };
        // }
        // return;
      }

      // Validation for numeric inputs
      if (input.type === "number") {
        if (!validateNumber(value)) {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }

      // Additional checks for required fields
      if (
        input.required &&
        input.type !== "number" &&
        (!value || value === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      if (
        // (input.type === "text" || input.type === "select") &&
        (input.type === "select" || input.type === "optionselect") &&
        !value?.trim()
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const parseNumericFields = (data) => {
    const parsedData = { ...data };
    if (parsedData.distanceCovered?.value) {
      parsedData.distanceCovered.value = parseFloat(
        parsedData.distanceCovered.value
      );
    }
    if (parsedData.freightLoad?.value) {
      parsedData.freightLoad.value = parseFloat(parsedData.freightLoad.value);
    }
    return parsedData;
  };

  const handleLocationChange = (fieldName, value) => {
    const newValue = value?.label || "";

    const newCoordinates = value
      ? { lat: value.latitude, lng: value.longitude }
      : null;

    setFormData((prevState) => {
      const updated = {
        ...prevState,
        [fieldName]: newValue,
      };

      const origin = fieldName === "origin" ? newValue : prevState.origin;
      const destination =
        fieldName === "destination" ? newValue : prevState.destination;

      if (!origin || !destination) {
        updated.distanceCovered = { value: "", unit: "" };
      }

      return updated;
    });

    // Set coordinates and fetch distance if both present
    if (fieldName === "origin") {
      setOriginCoordinates(newCoordinates);
    } else if (fieldName === "destination") {
      setDestinationCoordinates(newCoordinates);
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: value ? "" : prevErrors[fieldName],
    }));
  };

  const fetchDistance = async () => {
    if (!originCoordinates || !destinationCoordinates) return;
    try {
      let response = await get(
        `/scope3/airTransportation/distance?originLat=${originCoordinates.lat}&originLong=${originCoordinates?.lng}&destinationLat=${destinationCoordinates?.lat}&destinationLong=${destinationCoordinates?.lng}`
      );
      setFormData((prevData) => ({
        ...prevData,
        distanceCovered: {
          value: parseInt(response?.data?.data),
          unit: "Km",
        },
      }));
    } catch (error) {
      console.error("Error fetching ships:", error);
    }
  };

  useEffect(() => {
    if (SelectedData !== null) {
      setFormData(SelectedData);
      setFormData2(SelectedData);
      setUploadedFiles(SelectedData?.documents || []);

      // Set coordinates from selectedData if available
      if (SelectedData.originCoordinates) {
        setOriginCoordinates(SelectedData.originCoordinates);
      }

      if (SelectedData.destinationCoordinates) {
        setDestinationCoordinates(SelectedData.destinationCoordinates);
      }
    } else {
      setFormData(initialState);
      setFormData2(initialState);
      setUploadedFiles([]);
    }
  }, [SelectedData, addData]);

  useEffect(() => {
    if (!originCoordinates || !destinationCoordinates) {
      setFormData((prev) => ({
        ...prev,
        distanceCovered: { value: "", unit: "" },
      }));
      return;
    }

    fetchDistance();
  }, [originCoordinates, destinationCoordinates]);

  // useEffect(() => {
  //   if (originCoordinates && destinationCoordinates) {
  //     fetchDistance(originCoordinates, destinationCoordinates);
  //   }
  // }, [originCoordinates, destinationCoordinates]);

  const Save = async () => {
    if (!validateForm()) return;

    const keysToRemove = ["documents"];
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key]) => !keysToRemove.includes(key))
    );

    let dataToSend = {
      ...filteredFormData,
      // documents: uploadedFiles,
      transportationType: formData.transportationType.includes("Upstream")
        ? "Upstream"
        : "Downstream",
    };

    dataToSend = parseNumericFields(dataToSend);

    if (formData.typeOfEntry !== "Individual") {
      delete dataToSend.hours;
      delete dataToSend.industrialEquipment;
    }

    // Remove fields with empty values
    Object.keys(dataToSend).forEach((key) => {
      if (
        key !== "remark" &&
        (dataToSend[key] === "" ||
          (typeof dataToSend[key] === "object" &&
            Object.keys(dataToSend[key]).length === 0))
      ) {
        delete dataToSend[key];
      }
    });

    dataToSend = {
      ...dataToSend,
      documents: uploadedFiles,
    };
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }

    // let encryptedData = encryptData(dataToSend);
    // console.log("firs1", encryptedData, JSON.stringify(dataToSend));

    const url = SelectedData?._id
      ? `${updateUrl}?Id=${SelectedData?._id}`
      : `${addUrl}`;

    const method = SelectedData?._id ? put : post;
    try {
      const res = await method(url, dataToSend);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      fetchData();
      setFormData(initialState);
      setFormData2(initialState);
      setUploadedFiles([]);
      // handleClose();
      handleExitAgree();
      setdataView({});
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        const errorMessages = err.response.data.errors
          .map((error) => error.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      }
    }
  };

  const renderInputField = (el) => {
    if (el.options || el.type === "select") {
      return (
        // <SelectField
        //    title={formatTitleWithOptional(el.title)}
        //   name={el.fieldName}
        //   value={formData[el.fieldName]}
        //   handleChange={handleChange}
        //   options={el.options}
        //   errors={errors[el.fieldName]}
        //   url={el.url}
        //   field={el.field}
        // />
        <>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
            Transportation Type
          </Typography>
          <Select
            size="small"
            name="transportationType"
            value={formData?.transportationType || "Tap to Select"}
            fullWidth
            onChange={handleChange1("transportationType")}
            error={!!errors?.transportationType}
          >
            <MenuItem value="Tap to Select" disabled>
              Tap to Select
            </MenuItem>
            <MenuItem value="Upstream">Upstream Transportation</MenuItem>
            <MenuItem value="Downstream">Downstream Transportation</MenuItem>
          </Select>
          {errors?.transportationType && (
            <Typography variant="body2" color="error">
              {errors.transportationType}
            </Typography>
          )}
        </>
      );
    }

    if (el.fieldName === "origin") {
      return (
        <AirportAutocomplete
          title={"Source"}
          error={errors.origin}
          value={formData.origin}
          onChange={(newValue) => handleLocationChange("origin", newValue)}
          placeholder="Enter Source"
        />
      );
    }

    if (el.fieldName === "destination") {
      return (
        <AirportAutocomplete
          title={"Destination"}
          error={errors.destination}
          value={formData.destination}
          onChange={(newValue) => handleLocationChange("destination", newValue)}
          placeholder="Enter Destination"
        />
      );
    }

    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Consumption Month"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
            }}
          />
        </Box>
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "freightLoad" || el.fieldName === "distanceCovered") {
      const fieldData = formData[el.fieldName] || {}; // Get data for either freightLoad or distanceCovered
      const errorData = errors[el.fieldName] || {}; // Get errors for either freightLoad or distanceCovered

      // Set unit options based on the fieldName
      const unitOptions =
        el.fieldName === "freightLoad"
          ? ["Tonnes", "Kg", "Pound"]
          : ["Km", "mile"];

      const isDisabled = el.fieldName === "distanceCovered";
      console.log("qqqq", fieldData.value);
      return (
        <Box display="flex" gap={1} sx={{ width: "100%", mt: "0.5rem" }}>
          <Box sx={{ width: "55%" }}>
            <InputField
              title={formatTitleWithOptional(el.title)}
              handleChange={handleChange}
              placeholder={el.placeholder}
              value={
                el.fieldName === "distanceCovered" &&
                typeof fieldData.value === "number"
                  ? fieldData.value.toFixed(3)
                  : fieldData.value || ""
              }
              errors={errorData.value} // Access error for value
              fieldName={`${el.fieldName}.value`}
              disabled={isDisabled}
            />
          </Box>
          <Box sx={{ width: "45%", mt: "9%" }}>
            <SelectField
              name={`${el.fieldName}.unit`} // Dynamic field name for unit
              value={fieldData.unit}
              handleChange={handleChange}
              options={unitOptions} // Conditionally set options
              errors={errorData.unit} // Access error for unit
              field={el.field}
              disable={isDisabled}
              defaultValue="Select Unit"
            />
          </Box>
        </Box>
      );
    }

    if (el.fieldName === "remark")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null;
    }
    if (el.fieldName === "reasonForDeviation")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={
          el.fieldName === "quantityConsumed"
            ? formData[el.fieldName]?.value
            : formData[el.fieldName] || ""
        }
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        adornmentText={el.adornmentText || ""} // Pass error prop
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "26rem", maxWidth: "100%" }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {SelectedData?._id
            ? `Edit Air Transportation`
            : `Add Air Transportation`}
          {/* AddData */}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "industrialEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      {list()}
    </Drawer>
  );
}

export default AddTransportation;
